<template>
  <div>
    <template v-if="uiLoading">
      <div :class="['zm-skeleton', animated ? 'is-animated' : '', ]" v-bind="$attrs">
        <template v-for="i in count">
          <slot v-if="loading" name="template">
            <zm-skeleton-item
              v-for="item in rows"
              :key="`${i}-${item}`"
              :class="{
                'zm-skeleton__paragraph': item !== 1,
                'is-first': item === 1,
                'is-last': item === rows && rows > 1,
              }"
              variant="p"
            />
          </slot>
        </template>
      </div>
    </template>
    <template v-else>
      <slot v-bind="$attrs"></slot>
    </template>
  </div>
</template>
<script>
  import ZmSkeletonItem from '../skeleton-item';
  export default {
    name: 'ZmSkeleton',
    components: {
      ZmSkeletonItem: ZmSkeletonItem
    },
    props: {
      animated: {
        type: Boolean,
        default: false
      },
      count: {
        type: Number,
        default: 1
      },
      rows: {
        type: Number,
        default: 4
      },
      loading: {
        type: Boolean,
        default: true
      },
      throttle: {
        type: Number,
        default: 0
      }
    },
    watch: {
      loading: {
        handler(loading) {
          if (this.throttle <= 0) {
            this.uiLoading = loading;
            return;
          }
          if (loading) {
            clearTimeout(this.timeoutHandle);
            this.timeoutHandle = setTimeout(() => {
              this.uiLoading = this.loading;
            }, this.throttle);
          } else {
            this.uiLoading = loading;
          }
        },
        immediate: true
      }
    },
    data() {
      return {
        uiLoading: this.throttle <= 0 ? this.loading : false
      };
    }
  };
</script>
<style lang="scss">
@import "../../scss/mixins/mixins";
@import "../../scss/common/var";
@mixin skeleton-color() {
  background: linear-gradient(
    90deg,
    $--skeleton-color 25%,
    $--skeleton-to-color 37%,
    $--skeleton-color 63%
  );
  background-size: 400% 100%;
  animation: #{$namespace}-skeleton-loading 1.4s ease infinite;
}

@keyframes #{$namespace}-skeleton-loading {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}

@include b(skeleton) {
  width: 100%;
  @each $unit in (first-line, paragraph) {
    @include e($unit) {
      height: 16px;
      margin-top: 16px;
      background: $--skeleton-color;
    }
  }

  @include when(animated) {
    .#{$namespace}-skeleton__item {
      @include skeleton-color();
    }
  }
}
@mixin circle-size($size) {
  width: $size;
  height: $size;
  line-height: $size;
}

@include b(skeleton) {
  @include e(item) {
    background: $--skeleton-color;
    display: inline-block;
    height: 16px;
    border-radius: $--border-radius-base;
    width: 100%;
  }

  @include e(circle) {
    border-radius: 50%;
    @include circle-size($--avatar-medium-size);

    @include m(lg) {
      @include circle-size($--avatar-large-size);
    }

    @include m(md) {
      @include circle-size($--avatar-small-size);
    }
  }

  @include e(button) {
    height: 40px;
    width: 64px;
    border-radius: 4px;
  }

  @include e(p) {
    width: 100%;
    @include when(last) {
      width: 61%;
    }

    @include when(first) {
      width: 33%;
    }
  }

  @include e(text) {
    width: 100%;
    height: $--font-size-small;
  }

  @include e(caption) {
    height: $--font-size-small;
  }

  @include e(h1) {
    height: $--font-size-xl;
  }

  @include e(h3) {
    height: $--font-size-large;
  }

  @include e(h5) {
    height: $--size-md;
  }

  @include e(image) {
    width: unset;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0;

    svg {
      fill: $--svg-monochrome-grey;
      width: 22%;
      height: 22%;
    }
  }

}
.zm-theme--dark {
  @include b(skeleton) {
    @include e(item) {
      background: #444B53;
    }
  }
}
</style>
